import { useEffect } from "react";
import createActivity from "@/utils/client/createActivity";

export default function useSetActivity(name: string, sessionId: number) {
  useEffect(() => {
    const run = async () => {
      await createActivity(name, sessionId);
    };
    run();
    return function cleanup() {
      return;
    };
  }, [name, sessionId]);
}
